<template>

    <b-card>

        <b-row class="mb-2">

            <b-col lg="4" class="my-1">

                <b-form-select v-model="status">

                    <option value="all">All Claimants</option>
                    <option value="enrolled">Enrolled Claimants</option>
                    <option value="all_unenrolled">Unenrolled Claimants</option>
                    <option value="not_enrolled">Never Sent Enrollment</option>
                    <option value="incomplete">Incomplete Enrollment</option>
                </b-form-select>
            </b-col>
            <b-col lg="4" class="my-1">

                <b-form-select v-model=" specialistFilter ">

                    <option value="">For Specialist</option>
                    <option v-for=" admin in admins " :key=" admin.id " :value=" admin.id ">{{ admin.nameLastFirst }}</option>
                </b-form-select>
            </b-col>
            <b-col lg="4" class="my-1">

                <carrier-parents-dropdown v-model=" parentCarrier " emptyText="All Carriers" :disabled=" carrier != '' "></carrier-parents-dropdown>
            </b-col>
            <b-col lg="4" class="my-1">

                <carrier-dropdown v-model=" carrier " emptyText="Any Carrier Block"></carrier-dropdown>
            </b-col>
            <b-col lg="4" class="my-1">

                <b-form-select id="activeFilter" v-model="activeFilter">

                    <option value="">-- Filter Active/Inactive --</option>
                    <option value="active">Active Claimants</option>
                    <option value="inactive">Inactive (Deactivated) Claimants</option>
                </b-form-select>
            </b-col>
        </b-row>

        <b-row class="mb-2">

            <b-col md="6" sm="12" class="my-1">

                <b-input-group>

                    <template v-slot:prepend>

                        <b-input-group-text>Act on Selected:</b-input-group-text>
                    </template>
                    <b-form-select id="bulkAction" v-model=" bulkAction ">

                        <option value="">-- no action --</option>
                        <!--<option value="inactivate">Inactivate</option>-->
                        <!--<option value="activate">Activate</option>-->
                        <option value="send_email">Send Enrollment Email</option>
                        <option value="send_letter">Send Enrollment Letter</option>
                    </b-form-select>
                </b-input-group>
            </b-col>

            <b-col class="d-flex align-items-center justify-content-end my-1">

                <b-btn variant="info" @click=" loadTable() " :disabled=" loading " class="mr-2">Generate Report</b-btn>
                <b-btn variant="success" @click=" exportXls() ">
                    <i class="fa fa-file-excel-o"></i> Export to Excel
                </b-btn>
            </b-col>
        </b-row>

        <div class="table-responsive">

            <b-table bordered striped hover show-empty
                :items=" items "
                :fields=" fields "
                :current-page=" currentPage "
                :per-page=" 0 "
                :sort-by.sync=" sortBy "
                :sort-desc.sync=" sortDesc "
                :busy=" loading "
            >
                <template v-slot:head(checkbox)="data">

                    <b-button @click.prevent="toggleSelectAll()" variant="default">

                        <i class="fa fa-check"></i>
                    </b-button>
                </template>
                <template v-slot:cell(checkbox)="row">

                    <div class="form-check">

                        <b-form-checkbox v-model=" bulkIds " :value=" row.item.id "></b-form-checkbox>
                    </div>
                </template>
                <template v-slot:cell(actions)="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->

                    <b-btn size="sm" :href="'/business/clients/' + row.item.id" target="_blank">
                        <i class="fa fa-edit"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>

        <b-row>

            <b-col lg="6" >

                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
            </b-col>
            <b-col lg="6" class="text-right">

                {{ paginationText }}
            </b-col>
        </b-row>
    </b-card>
</template>

<script>

    import FormatsStrings from "../mixins/FormatsStrings";
    import FormatsDates from "../mixins/FormatsDates";
    import FormatsListData from "../mixins/FormatsListData";
    import EnrollmentStatuses from "../mixins/EnrollmentStatuses";
    import PaginatedTable from "../mixins/PaginatedTable";
    import ParentCarrierDropdown from "./CarrierParentsDropdown";

    export default {

        components: { ParentCarrierDropdown },
        mixins: [ FormatsStrings, FormatsDates, FormatsListData, EnrollmentStatuses, PaginatedTable ],

        props: {},

        data() {

            return {

                carrier          : '',
                parentCarrier    : '',
                status           : 'all',
                activeFilter     : '',
                specialistFilter : '',

                admins           : [],

                baseUrl          : '/business/clients',

                editModalVisible : false,
                modalDetails     : { index:'', data:'' },
                selectedItem     : {},
                bulkAction       : "",
                bulkIds          : [],

                fields: [

                    {
                        'key': 'checkbox',
                    },
                    {
                        key: 'firstname',
                        label: 'First Name',
                        sortable: true
                    },
                    {
                        key: 'lastname',
                        label: 'Last Name',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email Address',
                        sortable: true,
                        formatter: this.formatEmail
                    },
                    {
                        key: 'parent_carrier',
                        label: 'Carrier',
                        sortable: true
                    },
                    {
                        key: 'carrier_name',
                        label: 'Block',
                        sortable: true
                    },
                    {
                        key: 'enrollment_status',
                        label: 'Enrollment Status',
                        sortable: true,
                        formatter: this.formatEnrollmentStatus
                    },
                    {
                        key: 'enrollment_code',
                        label: 'Enrollment Code',
                        sortable: true,
                        formatter: x => { return x ? x : '-' },
                    },
                    {
                        key: 'enrollment_sent_at',
                        label: 'Enrollment Last Sent',
                        sortable: true,
                        formatter: (val) => ! val ? '-' : this.formatDateFromUTC(val),
                    },
                    {
                        key: 'enrolled_at',
                        label: 'Enrollment Date',
                        sortable: true,
                        formatter: (val) => !val ? '-' : this.formatDateFromUTC(val),
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ]
            }
        },

        mounted() {

            this.fetchAdmins();
        },

        computed: {

            appliedFilters(){ return `?ltc_carrier_id=${this.carrier}&parent_carrier_id=${this.parentCarrier}&active=${this.activeFilter}&status=${this.status}&specialistFilter=${this.specialistFilter}`; },
        },

        methods: {

            details(item, index, button) {

                this.selectedItem = item;
                this.modalDetails.data = JSON.stringify(item, null, 2);
                this.modalDetails.index = index;
//                this.$root.$emit('bv::show::modal','clientEditModal', button);
                this.editModalVisible = true;
            },
            resetModal() {
                this.modalDetails.data = '';
                this.modalDetails.index = '';
            },
            submitBulkAction(action){

                if (!this.bulkIds.length) {
                    this.bulkAction = "";
                    return alert("No clients were selected.");
                }

                let confirmAction = this.bulkAction;
                let postText = '';
                switch(this.bulkAction) {
                    case 'send_email':
                        confirmAction = 'send the enrollment email to';
                        postText = ' and their not-enrolled providers';
                        break;
                    case 'send_letter':
                        confirmAction = 'send the enrollment letter to';
                        postText = ' and their not-enrolled providers';
                        break;
                }
                if (!confirm('Are you sure you wish to ' + confirmAction + ' the selected ' + this.bulkIds.length + ' claimants' + postText + '?')) {
                    this.bulkAction = "";
                    return;
                }

                let form = new Form({
                    ids: this.bulkIds
                });
                this.bulkAction = "";
                form.post('/business/clients/bulk/' + action);
            },
            fetchAdmins() {
                axios.get('/business/specialists')
                    .then( ({ data }) => {
                        this.admins = data;
                    })
                    .catch(e => {
                        this.admins = [];
                    })
            },
            toggleSelectAll() {
                if (this.bulkIds.length == this.items.length) {
                    this.bulkIds = [];
                    return;
                }
                this.bulkIds = this.items.map(obj => obj.id);
            }
        },

        watch: {

            bulkAction(val) {

                if (val) this.submitBulkAction(val);
            }
        }
    }
</script>
